<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#CFD8DC"
      d="M5,39V15h38v24c0,2.209-1.791,4-4,4H9C6.791,43,5,41.209,5,39"
    />
    <path fill="#ECEFF1" d="M5 25H43V33H5z" />
    <path fill="#B0BEC5" d="M13 27H17V31H13zM19 27H23V31H19zM31 27H35V31H31z" />
    <path
      fill="#90A4AE"
      d="M13 21H17V25H13zM19 21H23V25H19zM25 21H29V25H25zM31 21H35V25H31zM13 33H17V37H13zM19 33H23V37H19zM25 33H29V37H25zM31 33H35V37H31z"
    />
    <g>
      <path
        fill="#F44336"
        d="M25 27H29V31H25zM43 11v6H5v-6c0-2.209 1.791-4 4-4h30C41.209 7 43 8.791 43 11"
      />
    </g>
    <g>
      <path
        fill="#B71C1C"
        d="M36 11c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3S36 9.343 36 11M18 11c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3S18 9.343 18 11"
      />
    </g>
    <g>
      <path
        fill="#B0BEC5"
        d="M33 4c-1.104 0-2 .896-2 2v5c0 1.104.896 2 2 2s2-.896 2-2V6C35 4.896 34.104 4 33 4M15 4c-1.104 0-2 .896-2 2v5c0 1.104.896 2 2 2s2-.896 2-2V6C17 4.896 16.104 4 15 4"
      />
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "TearOffCalendarIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
